import { LanguageToggle } from './lib/language-toggle.js';
customElements.define('cipublic-language-toggle', LanguageToggle);
//# sourceMappingURL=cipublic-language-toggle.js.map